import { Accordion, AccordionTab } from "primereact/accordion";
import UploadUI from "@UI/UploadUI";
import RadioButtonUI from "@UI/RadioButtonUI";
import { useState } from "react";
import { inject, observer } from "mobx-react";

import "./style.scss";

const dataRadioButton = [
    { label: "Определение и разделение данных по офферам/вендорам", value: "definitionDivision" },
    { label: "Разделение  файла на части ≤250 тыс. записей", value: "partsDivision" },
];

const Formatter = inject("mainStore")(
    observer(({ mainStore }) => {
        const [radio, setRadio] = useState("definitionDivision");

        const handleUpload = async (e) => {
            const file = e.files?.[0];

            const formData = new FormData();
            formData.append("file", file);

            if (radio === "definitionDivision") {
                const resp = await mainStore.downloadFile(
                    `/supplymethods/get_promo_data_by_code`,
                    formData,
                    {
                        responseType: "blob",
                    },
                    `promoDataByCode.xls`,
                );
            } else {
                const resp = await mainStore.downloadFile(
                    `/supplymethods/split_promo_file`,
                    formData,
                    {
                        responseType: "blob",
                    },
                    `tar.gz`,
                );
            }
            e.options.clear();
        };

        return (
            <Accordion className="activate-formatter">
                <AccordionTab header="Форматировать документ">
                    <RadioButtonUI radioData={dataRadioButton} value={radio} onChange={(e) => setRadio(e.value)} />
                    <UploadUI formats={radio === "definitionDivision" ? "XLSX, XLS" : "CSV, TXT"} handleUpload={handleUpload} />
                </AccordionTab>
            </Accordion>
        );
    }),
);

export default Formatter;
